import { makeActionCreator } from 'crazyEditor/redux/helpers';
import update from 'immutability-helper';
import _ from 'lodash';
const SET_WINDOW_BUSY = 'general/SET_WINDOW_BUSY';
const UPDATE_TASK_PROGRESS = 'general/UPDATE_TASK_PROGRESS';
const CLEAR_TASK_PROGRESS = 'general/CLEAR_TASK_PROGRESS';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case SET_WINDOW_BUSY:
      return {
        ...state,
        windowBusy: action.windowBusy,
      };
    case UPDATE_TASK_PROGRESS:
      const {key, percent, done, stats, index} = action.message;
      if (state.progress[key] && index <= state.progress[key].index) { // prevent out of order updates.
        return state;
      }
      return update(state, {
        progress: {
          [key]: {$set: {percent, done, stats, index}}
        }
      });
    case CLEAR_TASK_PROGRESS:
      const {taskKey} = action;
      return update(state, {
        progress: {$apply: progress => _.omit(progress, taskKey)},
      });
    default:
      break;
  }
  return state;
}

export const setWindowBusy = makeActionCreator(SET_WINDOW_BUSY, 'windowBusy');
export const updateTaskProgress = makeActionCreator(UPDATE_TASK_PROGRESS, 'message');
export const clearTaskProgress = makeActionCreator(CLEAR_TASK_PROGRESS, 'taskKey');
